import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext, useMemo } from 'react';
import { Typeahead } from '../Typeahead/Typeahead';
import { useFieldValue } from '../hooks/field-value';
import { SchemaContext } from '../providers/SchemaProvider';
import { FieldWrapper } from './FieldWrapper';
import { isDefined } from '../utils';
export const EnumField = ({ propName, required }) => {
    var _a, _b;
    const { schema } = useContext(SchemaContext);
    const { value = '', onChange, disabled, errors } = useFieldValue(propName);
    if (!isDefined(schema)) {
        throw new Error(`StringField: schema is not defined for ${propName}`);
    }
    const items = useMemo(() => {
        var _a, _b;
        return (_b = (_a = schema === null || schema === void 0 ? void 0 : schema.enum) === null || _a === void 0 ? void 0 : _a.map((item) => ({
            name: String(item),
            description: '',
            value: String(item),
        }))) !== null && _b !== void 0 ? _b : [];
    }, [schema]);
    const selectedItem = useMemo(() => {
        var _a;
        if (!value) {
            return undefined;
        }
        if (typeof value === 'object') {
            return {
                value: JSON.stringify(value),
                name: JSON.stringify(value),
                description: '',
            };
        }
        return (_a = items.find((item) => item.name === value)) !== null && _a !== void 0 ? _a : { value: value, name: value, description: '' };
    }, [items, value]);
    const onItemChange = useCallback((item) => {
        onChange(item === null || item === void 0 ? void 0 : item.name);
    }, [onChange]);
    const onCleanInput = useCallback(() => {
        onChange(undefined);
    }, [onChange]);
    return (_jsx(FieldWrapper, { propName: propName, required: required, title: schema.title, errors: errors, type: "enum", description: schema.description, defaultValue: (_a = schema.default) === null || _a === void 0 ? void 0 : _a.toString(), children: _jsx(Typeahead, { "data-testid": propName, selectedItem: selectedItem, items: items, placeholder: (_b = schema.default) === null || _b === void 0 ? void 0 : _b.toString(), id: propName, onChange: onItemChange, onCleanInput: onCleanInput, disabled: disabled }) }));
};
//# sourceMappingURL=EnumField.js.map